<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Ikoner
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sajten använder <strong>lucide-vue-next</strong> för UI-ikoner och
      <strong>@phosphor-icons/vue</strong> (PhHeart) för gilla-hjärtat på
      receptkorten.
    </p>

    <PreviewBox label="lucide-vue-next — alla ikoner i bruk" bg="white">
      <div
        v-for="item in icons"
        :key="item.name"
        class="flex flex-col items-center gap-1.5 p-3 rounded-xl border border-[#eceef0] min-w-[80px]"
      >
        <component :is="item.icon" :size="20" color="#3c4947" />
        <span class="font-mono text-[9px] text-[#191c1e] text-center">{{
          item.name
        }}</span>
        <span
          class="font-[Plus_Jakarta_Sans] text-[9px] text-[#a0b0ae] text-center"
          >{{ item.where }}</span
        >
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import {
  Heart,
  Search,
  ArrowRight,
  ArrowLeft,
  Menu,
  X,
  User,
  Info,
  RotateCcw,
  ChevronDown,
  ChevronUp,
  Lightbulb,
  AlertTriangle,
  CheckCircle2,
  Pencil,
  Trash2,
} from "lucide-vue-next";
import CodeBlock from "../components/CodeBlock.vue";
import PreviewBox from "../components/PreviewBox.vue";

const icons = [
  { icon: Search, name: "Search", where: "Navbar" },
  { icon: Heart, name: "Heart", where: "Navbar" },
  { icon: User, name: "User", where: "Navbar" },
  { icon: Menu, name: "Menu", where: "Navbar" },
  { icon: X, name: "X", where: "Navbar / Sök" },
  { icon: ArrowRight, name: "ArrowRight", where: "Knappar" },
  { icon: ArrowLeft, name: "ArrowLeft", where: "Degkalkylator" },
  { icon: ChevronDown, name: "ChevronDown", where: "Degkalkylator" },
  { icon: ChevronUp, name: "ChevronUp", where: "Degkalkylator" },
  { icon: RotateCcw, name: "RotateCcw", where: "Degkalkylator" },
  { icon: Info, name: "Info", where: "Degkalkylator" },
  { icon: Lightbulb, name: "Lightbulb", where: "Teknik / Tips" },
  { icon: AlertTriangle, name: "AlertTriangle", where: "Teknik / Varning" },
  { icon: CheckCircle2, name: "CheckCircle2", where: "Teknik / Punkter" },
  { icon: Pencil, name: "Pencil", where: "Admin" },
  { icon: Trash2, name: "Trash2", where: "Admin" },
];

const htmlCode = `<!-- Importera från lucide-vue-next -->
import { Search, ArrowRight } from 'lucide-vue-next'

<!-- Används i template -->
<Search :size="20" />
<ArrowRight :size="20" color="#14b8a6" />

<!-- PhHeart (gilla-knapp) kommer från @phosphor-icons/vue -->
import { PhHeart } from '@phosphor-icons/vue'
<PhHeart :size="20" weight="fill" color="#f43f5e" />`;
const cssCode = `/* Standard ikonstörlek */
width: 18px;     /* :size="18" — nav, knappar */
width: 16px;     /* :size="16" — in-line, meta */

/* Stroke-bredd */
stroke-width: 2;   /* lucide default */

/* Bibliotek */
/* lucide-vue-next  — alla UI-ikoner */
/* @phosphor-icons/vue — PhHeart (gilla-knapp) */`;

const snippetTabs = [
  { label: "Vue", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
